import { BookingDateException, WorkTimeType } from 'shared/types';

import getNearestBusinessDay from './getNearestBusinessDay';
import getNearestPreOrderWorkTime from './getNearestPreOrderWorkTime';

type Props = {
	workTimeAll?: WorkTimeType[];
	delay?: number;
	exceptions?: BookingDateException[];
	minPreOrdersDayCount?: number;
};

/**
 * Get date with minimum days before user can make preorder.
 * */
const getNearestPreOrderBusinessDay = ({
	minPreOrdersDayCount,
	exceptions,
	delay,
	workTimeAll,
}: Props) => {
	if (!minPreOrdersDayCount || minPreOrdersDayCount === 0 || !workTimeAll) {
		return getNearestBusinessDay({ workTimeAll, delay, exceptions });
	}

	const { fromDelayed } = getNearestPreOrderWorkTime({
		minPreOrdersDayCount,
		workTimeAll,
		delay,
		exceptions,
	});

	return fromDelayed;
};

export default getNearestPreOrderBusinessDay;
